"use client";

import { getUuid } from "api/uuid.api";
import { memo, useEffect, useState } from "react";
import { getSecurityUuid, setSecurityUuid } from "util/localStorageUtils";
import yieldToMain from "util/lodash/yieldToMain";
import withErrorHandler from "./design-system/withErrorHandler";
import SignifydSecurityTimestamp from "./SignifydSecurityTimestamp";

function Signifyd() {
  const [uuid, setUuid] = useState<string>("");

  function updateUuid(newUuid: string) {
    yieldToMain().then(() => {
      setTimeout(() => {
        setUuid(newUuid);
      }, 1000 * 10);
      setSecurityUuid(JSON.stringify({
        uuid: newUuid,
        timestamp: new Date().getTime(),
      }));
    });
  }

  useEffect(() => {
    yieldToMain().then(() => {
      const securityUuid = getSecurityUuid();
      const currentTime = new Date().getTime();
      // 1 day expiry
      const generateUuid = !securityUuid || !securityUuid.uuid || currentTime > securityUuid.timestamp + (1000 * 60 * 60 * 24);
      if (!generateUuid) {
        updateUuid(securityUuid.uuid);
      } else {
        getUuid()
          .then(({ data }) => {
            updateUuid(data.uuid);
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    });
  }, []);

  // Separate useEffect to handle script loading
  useEffect(() => {
    // Only load script if we have a UUID
    if (uuid) {
      // Check if script already exists in DOM
      const existingScript = document.getElementById("sig-api");

      if (!existingScript) {
        const script = document.createElement("script");
        script.id = "sig-api";
        script.src = "https://cdn-scripts.signifyd.com/api/script-tag.js";
        script.async = true;
        script.defer = true;
        script.setAttribute("data-order-session-id", uuid);

        document.head.appendChild(script);
      } else {
        // Script already exists, just update the order session ID
        existingScript.setAttribute("data-order-session-id", uuid);
      }
    }
  }, [uuid]);

  return <SignifydSecurityTimestamp uuid={uuid} />;
}

export default withErrorHandler(memo(Signifyd));
